"use client";
import { CartContext } from "@repo/contexts/CartContext";
import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { useRemoveFromCart } from "@repo/lib/hooks/gtm";
import { useTrackRemoveFromCart } from "@repo/lib/hooks/webengage";
import { deletetemFromCart } from "@repo/server-actions/cart";
import { LoadingDots } from "@repo/ui";
import { useLocale, useTranslations } from "next-intl";
import { useCallback, useContext, useTransition } from "react";

const DeleteButton = (props) => {
  const locale = useLocale();
  const [isPending, startTransition] = useTransition();
  const { setCartTotalsInfo } = useContext(CartContext);
  const { item } = props;
  const t = useTranslations("Common");
  const { handleRemoveFromCartEvent } = useRemoveFromCart();
  const { showSnackbar } = useSnackbarHandler();
  const { trackRemoveFromCartEvent } = useTrackRemoveFromCart();

  const handleDeleteItem = useCallback(
    async (id) => {
      startTransition(async () => {
        const response = await deletetemFromCart(id, locale);
        if (response?.success) {
          setCartTotalsInfo(response);
          handleRemoveFromCartEvent(item);
          trackRemoveFromCartEvent(item);
        }
        showSnackbar(response);
      });
    },
    [
      setCartTotalsInfo,
      locale,
      handleRemoveFromCartEvent,
      item,
      showSnackbar,
      trackRemoveFromCartEvent,
    ]
  );

  return (
    <button onClick={() => handleDeleteItem(item?.id)}>
      {isPending ? (
        <LoadingDots className="bg-black" />
      ) : (
        <span className="text-miniCart-link text-sm font-medium hover:underline">
          {t("Delete")}
        </span>
      )}
    </button>
  );
};

export default DeleteButton;
